import type { AdvisoryManagementResourceDictionary } from "AdvisoryManagement/Translations/ResourceDictionary";
import { ContractType } from "Infrastructure/Api/Api";

export const AdvisoryManagementCzechResourcesDictionary: AdvisoryManagementResourceDictionary =
	{
		AppName: "Správce obchodu",
		Shared: {
			InvestmentQuestionnaireNotFound:
				"Klient nedisponuje platným investičním dotazníkem.",
			InvestmentQuestionnaireCompleted: "Investiční dotazník vyplněn {{date}}.",
			InvestmentQuestionnaireWarning: "Investiční dotazník obsahuje chyby.",
		},
		InvestmentQuestionnaire: {
			Error: {
				General: "Nastala chyba při načítání investičního dotazníku.",
				QuestionnaireExpired: "Platnost investičního dotazníku vypršela.",
			},
		},
		Components: {},
		Enums: {
			ContractType: {
				[ContractType.New]: "Nová smlouva",
				[ContractType.Modification]: "Modifikace smlouvy",
			},
		},
		Pages: {},
	};
